<template>
<div>
    <div v-if="isMutation" class="form-row">
        <div class="col-7">
            <span>Effective On: </span>
            <span>{{ $filters.date(job.effective_on) }}</span>
        </div>

        <div class="col-5 text-right">
            <a v-if="mode == 'full'" href @click.prevent="mode = 'diff'">Show Changes</a>
            <a v-if="mode == 'diff'" href @click.prevent="mode = 'full'">Show Full Job Info</a>
        </div>

        <div class="col-12">Created by: {{ job.created_by ? job.created_by.email : '--' }}</div>
    </div>

    <div v-else>
        <span>Last Modified Date: </span>
        <span>{{ $filters.date(job.updated_on) }}</span>
        <div>Created by: {{ job.created_by ? job.created_by.email : '--' }}</div>
    </div>

    <div v-if="mode == 'diff'" class="mt-2">
        <h5>Changes</h5>

        <div v-if="diff.pay_type_pretty">
            <span>Pay Type: </span>
            <span>{{ diff.pay_type_pretty.old }} -&gt; {{ diff.pay_type_pretty.cur }}</span>
        </div>

        <div v-if="diff.hourly_rate">
            <span>Hourly Rate: </span>
            <span>{{ $filters.dollars(diff.hourly_rate.old) }} -&gt; {{ $filters.dollars(diff.hourly_rate.cur) }}</span>
        </div>

        <div v-if="diff.tip_credit_rate">
            <span>Tip Credit Rate: </span>
            <span>{{ $filters.dollars(diff.tip_credit_rate.old) }} -&gt; {{ $filters.dollars(diff.tip_credit_rate.cur) }}</span>
        </div>

        <div v-if="diff.salary_rate">
            <span>Salary Rate: </span>
            <span>{{ $filters.dollars(diff.salary_rate.old) }} -&gt; {{ $filters.dollars(diff.salary_rate.cur) }}</span>
        </div>

        <div v-if="diff.default_hours">
            <span>Default Hours: </span>
            <span>{{ diff.default_hours.old }} -&gt; {{ diff.default_hours.cur }}</span>
        </div>

        <div v-if="diff.additional_compensation" class="mt-2">
            <b>Additional Compensation</b> <br />
            <ul>
                <li v-for="ac in diff.additional_compensation">
                    <span v-if="ac.added"><b>Added</b> {{ earningTypeLookup[ac.added.earning_type_slug]?.name }} {{ ac.added.rate ? $filters.dollars(ac.added.rate) : '' }}</span>
                    <span v-if="ac.removed"><b>Removed</b> {{ earningTypeLookup[ac.removed.earning_type_slug]?.name }} {{ ac.removed.rate ? $filters.dollars(ac.removed.rate) : '' }}</span>
                    <span v-if="ac.updated"><b>Updated</b>
                        {{ earningTypeLookup[ac.updated.earning_type_slug]?.name }} {{ $filters.dollars(ac.updated.old) }} -&gt; {{ $filters.dollars(ac.updated.cur) }}
                    </span>
                </li>
            </ul>
        </div>

    </div>

    <div v-if="mode == 'full'" class="mt-2">
        <h5>Job Info</h5>

        <div v-if="['S', 'SNE'].includes(job.pay_type)">
            <span>Salary Rate: </span> <span>{{ $filters.dollars(job.salary_rate) }}/pay period</span><br />
            <span>Default Hours: </span> <span>{{ job.default_hours }}</span><br />
        </div>

        <div v-if="['H'].includes(job.pay_type)">
            <span>Hourly Rate: </span> <span>{{ $filters.dollars(job.hourly_rate) }}/hour</span><br />
            <span>Tip Credit Rate: </span> <span>{{ job.tip_credit_rate ? '$' + job.tip_credit_rate : 'N/A' }}</span><br />
        </div>

        <div v-if="['P'].includes(job.pay_type)">
            <span>Unit Rate: </span> <span>{{ $filters.dollars(job.unit_rate) }}/unit</span><br />
        </div>

        <div v-if="job.additional_compensation.length" class="my-2">
            <b>Additional Compensation</b>
            <ul>
                <li v-for="ac in job.additional_compensation">
                    <span>{{ earningTypeLookup[ac.earning_type_slug]?.name }}</span>
                    <span v-if="earningTypeLookup[ac.earning_type_slug]?.type == 'hourly'">, {{ $filters.dollars(ac.rate) }}/hour</span>
                    <span v-if="earningTypeLookup[ac.earning_type_slug]?.type == 'per-unit'">, {{ $filters.dollars(ac.rate) }}/unit</span>
                </li>
            </ul>
        </div>
    </div>

</div>
</template>

<script>

export default {
    props: ['isMutation', 'job', 'diff', 'earningTypeLookup'],
    data() {
        return {
            mode: this.isMutation ? 'diff' : 'full',  // Can be diff or full
        }
    },
}
</script>
